import { useParams } from "react-router-dom";
import FormActions, {
  SchemaFormAction,
} from "../../components/forms/FormActionNew/FormAction";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import { useCrudAction } from "../../features/api/crud/hooks/useCrudAction";
import styles from "./PageConstatActionCreate.module.scss";
import { useMemo } from "react";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import dayjs from "dayjs";
import {
  useFetchConstatQuery,
  useFetchUsersForFieldQuery,
} from "../../features/api/apiSlice";

const PageConstatActionCreate: React.FC = () => {
  const { constatId } = useParams<{ constatId: string }>();

  const { onSubmit, isLoading, isPostingAttachments } = useCrudAction(
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "constat",
  );

  const { data: constat, isFetching: isFetchingConstat } = useFetchConstatQuery(
    Number(constatId),
    {
      skip: !constatId,
    },
  );

  const { data: dataPerformers, isFetching: isFetchingPorformers } =
    useFetchUsersForFieldQuery("");

  const defaultValues: SchemaFormAction = useMemo(() => {
    return {
      eventType: "CONSTAT",
      dateAsked: dayjs(),
      date: dayjs(),
      causeType: "CORRECTIF",
      title: "",
      description: "",
      effacity: "",
      pilote: "",
      performer: "",
      event: String(constatId),
    };
  }, [constatId]);

  const isPageLoading =
    isLoading || isFetchingConstat || isFetchingPorformers || isPostingAttachments;

  return (
    <PageLayout pageContainerClassName={styles.root} isLoading={isPageLoading}>
      <Breadcrumbs
        pageName="newConstatAction"
        eventName={constat?.name}
        eventId={Number(constatId)}
      />
      <FormActions
        onSubmit={onSubmit}
        isLoading={isLoading || isPostingAttachments}
        defaultValues={defaultValues}
        performers={dataPerformers || []}
      />
    </PageLayout>
  );
};

export default PageConstatActionCreate;
